export enum PaxTypeCode {
    TICKET = 'TICKET',
    STUDENT = 'STUDENT',
    TODDLER = 'TODDLER',
    INFANT = 'INFANT',
    SENIOR = 'SENIOR',
    YOUTH = 'YOUTH',
    CHILD = 'CHILD',
    ADULT = 'ADULT',
    PERSON = 'PERSON',
    BOOK = 'BOOK',
    UNKNOWN = 'UNKNOWN',
}
